/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2019 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/

import { observer } from "mobx-react";
import ServiceRegistry from "bundle/util/ServiceRegistry";
import PreviewBase from "bundle/preview/react-component/preview/presentation/Preview";
import { isMobileBrowser } from "bundle/util/AppUtil";

@observer
export default class Preview extends PreviewBase {
    correctSearchUI() {
        const appStore = ServiceRegistry.getService("AppStore");
        if (this._searchInterval || !appStore.adjustSearchUI) {
            return;
        }

        const searchCorrection = () => {
            if (appStore.searchOpen && document.querySelector(".SearchInputUI__SearchInputUI___15hhd")) {
                const se = document.querySelector(".SearchInputUI__SearchInputUI___15hhd");
                if (se.style.width && se.style.width === "100%" && isMobileBrowser()) {
                    se.style.top = "0px";
                    se.style.right = "0px";
                } else {
                    se.style.top = "42px";
                    if (appStore.enableModernViewer) {
                        se.style.top = "55px";
                        se.style.right = "73px";
                        se.style.width = "378px";
                    } else if (appStore.isIntegration) {
                        se.style.right = "0px";
                    } else {
                        se.style.right = "50px";
                    }
                }
            }
        };

        searchCorrection();
        this._searchInterval = setInterval(searchCorrection, 10);
    }
}
